import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import TaskService from "service/TaskService";
import { TaskDetailResp } from "domain/payload/response/task/TaskDetailResp";

const TaskDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const auth = useSelector((state: any) => state.auth);
  const { sessionId } = useSelector((state: any) => state.auth);

  const [data, setData] = React.useState<TaskDetailResp | null>(null);
  const taskService = TaskService();

  const loadTaskDetail = async () => {
    console.log(auth)
    try {
      const res = await taskService.taskWebFormDetail(sessionId);
      setData(res.data || null);
    } catch (error) {
      console.error("Load Task Detail Error:", error);
    }
  };

  useEffect(() => {
    loadTaskDetail();
  }, []);

  return (
    <div
      className="bg-white min-vh-100"
      style={{ paddingBottom: "90px" }}
    >
      <div className="container bg-white rounded-top mt-n2 pt-3 pb-5">
        {!data ? (
          <div className="text-center py-5">Loading...</div>
        ) : (
          <>
            <div className="mb-3">
              <small className="text-muted">Name</small>
              <h6 className="fw-bold">{data.taskName}</h6>
            </div>

            <div className="mb-3">
              <small className="text-muted">Type</small>
              <div className="fw-semibold">Quick Survey</div>
            </div>

            <div className="mb-3">
              <small className="text-muted">Description</small>
              <div>{data.taskDescription}</div>
            </div>

            <div className="mb-4">
              <small className="text-muted">Instruction</small>
              <div
                className="mt-2"
                dangerouslySetInnerHTML={{ __html: data.taskInstruction }}
              />
            </div>
          </>
        )}
      </div>

      <div
        className="fixed-bottom bg-white p-3 border-top"
        style={{
          zIndex: 1030,
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        <button
          className="btn btn-primary w-100"
          onClick={() => navigate("/submission?sId=" + sessionId)}
        >
          Mulai
        </button>
      </div>
    </div>
  );
};

export default TaskDetailPage;